/**
 * CabinClassSelector — segmented control for the cabin class.
 * Defaults to "Economy".
 *
 * @param {Object} props
 * @param {string} props.value
 * @param {(cabin:string) => void} props.onChange
 */
import React from "react";
import "./cabin-class-selector.css";

export const CABIN_CLASSES = ["Economy", "Premium Economy", "Business", "First"];

export default function CabinClassSelector({ value, onChange }) {
  return (
    <div className="ccs">
      <label className="ccs__label">Cabin Class</label>
      <div className="ccs__options" role="radiogroup" aria-label="Cabin class">
        {CABIN_CLASSES.map((cabin) => (
          <button
            type="button"
            key={cabin}
            role="radio"
            aria-checked={value === cabin}
            className={`ccs__option ${value === cabin ? "ccs__option--active" : ""}`}
            onClick={() => onChange(cabin)}
          >
            {cabin}
          </button>
        ))}
      </div>
    </div>
  );
}
